import { forwardRef, type Ref, type SVGProps } from "react";
const IconCompassOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M21.999 11.49a1.55 1.55 0 0 0-.44-1.06 1.52 1.52 0 0 0-1.42-.38l-11 2.9a1.49 1.49 0 0 0-1.14 1.34v.1c0 .606.368 1.152.93 1.38l5.07 2.23 2.23 5.07a1.49 1.49 0 0 0 2.77-.17l2.9-11q.047-.181.05-.37zm-2.21.71-2.3 8.8-1.66-3.78-.31-.71-.71-.31-3.81-1.69z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M25.899 25.9a14 14 0 1 0-9.9 4.1 13.94 13.94 0 0 0 9.9-4.1m-18.39-1.41A12 12 0 1 1 24.47 7.51 12 12 0 0 1 7.51 24.49"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCompassOutlineSVG);
ForwardRef.displayName = "IconCompassOutline";
export { ForwardRef as IconCompassOutline };
